import baseRoute from '../baseRoute';

export default `${baseRoute}/jobTracking` as const;
